import gql from 'graphql-tag';

/**
 * create a new channel
 */
export const CREATE_NEW_CHANNEL = gql`
  mutation($details: NewChannelInput!) {
    createChannel(details: $details) {
      id
      name
      topic
      private
      directMessage
      createdAt
      createdById
      lastMessageSentAt
      mostRecentMessage {
        message
        createdAt
      }
      memberIds
      broadcastType
      broadcastTypeId
    }
  }
`;

/**
 * send a new message in a channel
 */
export const POST_MESSAGE_TO_CHANNEL = gql`
  mutation($channelId: String!, $message: String!) {
    postMessageToChannel(input: {
      channelId: $channelId,
      message: $message
    }) {
      id
      channelId
      senderId
      message
      createdAt
      user {
        id
        name
        avatar
      }
      attachment {
        url
        key
        type
      }
    }
  }
`;

/**
 * send an attachment in a channel
 */
export const POST_ATTACHMENT_MESSAGE_TO_CHANNEL = gql`
  mutation($channelId: String!, $message: String!, $attachmentS3Key: String!) {
    postMessageToChannel(input: {
      channelId: $channelId,
      message: $message,
      attachmentS3Key: $attachmentS3Key
    }) {
      id
      channelId
      senderId
      message
      createdAt
      user {
        id
        name
        avatar
      }
      attachment {
        url
        key
        type
      }
    }
  }
`;

export const JOIN_CHANNEL = gql`
  mutation($channelId: String!) {
    joinChannel(channelId: $channelId) {
      id
      channelId
      userId
      channel {
        id
        name
        topic
        private
        directMessage
        createdAt
        lastMessageSentAt
      }
    }
  }
`;

export const LEAVE_CHANNEL = gql`
  mutation($channelId: String!) {
    leaveChannel(channelId: $channelId) {
      id
      channelId
      userId
      channel {
        id
        name
        topic
        private
        directMessage
        createdAt
        lastMessageSentAt
      }
    }
  }
`;

export const ADD_NEW_MEMBERS_TO_CHANNEL = gql`
  mutation($ids: [String]!, $channelId: String!) {
    addNewMembersToChannel(ids: $ids, channelId: $channelId) {
      id
      userId
      channelId
    }
  }
`;

export const ARCHIVE_CHANNEL = gql`
  mutation($channelId: String!) {
    archiveChannel(channelId: $channelId) {
      id
    }
  }
`;

export const MARK_MESSAGES_AS_READ_FOR_CHANNEL = gql`
  mutation($channelId: String!) {
    markAllMessagesAsReadForChannel(channelId: $channelId) {
      id
      channelId
    }
  }
`;
